var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardConversation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 6,
    fill: "#F1F1F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6926_2444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5679 20.6394H33.2905V20.4322C33.2905 19.7805 32.7602 19.25 32.1083 19.25H20.4322C19.7805 19.25 19.25 19.7803 19.25 20.4322V28.8977C19.25 29.5494 19.7803 30.0799 20.4322 30.0799H20.7938V31.2585C20.7938 31.9102 21.3241 32.4407 21.976 32.4407H22.3314C22.6912 32.4407 23.0422 32.5882 23.2943 32.8451L25.1054 34.6919C25.1419 34.7289 25.1917 34.75 25.2438 34.75C25.2959 34.75 25.3457 34.7291 25.3821 34.6919L27.1931 32.8451C27.4451 32.5882 27.796 32.4407 28.156 32.4407H33.5681C34.2199 32.4407 34.7502 31.9104 34.7502 31.2585V21.8214C34.75 21.1697 34.2197 20.6394 33.5679 20.6394ZM20.4322 29.6924C19.994 29.6924 19.6375 29.3359 19.6375 28.8977V20.4322C19.6375 19.994 19.994 19.6375 20.4322 19.6375H32.1084C32.5467 19.6375 32.9032 19.994 32.9032 20.4322V20.6392H21.976C21.3243 20.6392 20.7938 21.1695 20.7938 21.8214V29.6924H20.4322ZM34.3625 31.2585C34.3625 31.6967 34.006 32.0532 33.5679 32.0532H28.1558C27.6926 32.0532 27.2407 32.2429 26.9164 32.5738L25.2438 34.2796L23.571 32.5738C23.2466 32.2431 22.7948 32.0532 22.3316 32.0532H21.9762C21.538 32.0532 21.1815 31.6967 21.1815 31.2585V21.8214C21.1815 21.3832 21.538 21.0267 21.9762 21.0267H33.5681C34.0062 21.0267 34.3627 21.3832 34.3627 21.8214L34.3625 31.2585Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_6926_2444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3088 29.4831C26.3088 29.3357 26.4283 29.2163 26.5757 29.2163L30.9831 29.2163C31.1305 29.2163 31.25 29.3357 31.25 29.4831C31.25 29.6305 31.1305 29.75 30.9831 29.75L26.5757 29.75C26.4283 29.75 26.3088 29.6305 26.3088 29.4831ZM30.9729 27.75C31.1203 27.75 31.2398 27.8695 31.2398 28.0169C31.2398 28.1643 31.1203 28.2837 30.9729 28.2837L23.5169 28.2837C23.3695 28.2837 23.25 28.1643 23.25 28.0169C23.25 27.8695 23.3695 27.75 23.5169 27.75L30.9729 27.75Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.1912 24.9831C28.1912 24.8357 28.0717 24.7163 27.9243 24.7163L23.5169 24.7163C23.3695 24.7163 23.25 24.8357 23.25 24.9831C23.25 25.1305 23.3695 25.25 23.5169 25.25L27.9243 25.25C28.0717 25.25 28.1912 25.1305 28.1912 24.9831ZM23.5271 23.25C23.3797 23.25 23.2602 23.3695 23.2602 23.5169C23.2602 23.6643 23.3797 23.7837 23.5271 23.7837L30.9831 23.7837C31.1305 23.7837 31.25 23.6643 31.25 23.5169C31.25 23.3695 31.1305 23.25 30.9831 23.25L23.5271 23.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6926_2444",
    x: 19.25,
    y: 27.75,
    width: 16,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6926_2444"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6926_2444",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6926_2444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardConversation);
export default __webpack_public_path__ + "static/media/dashboard_conversation.461d431c9dd19f4a575b3e1a73bf3f5a.svg";
export { ForwardRef as ReactComponent };